import "./helpers/settingsModalHash";
import "./helpers/safeStorage";
import { pageHome } from "./pages/pageHome";
import { pageCheckout } from "./pages/pageCheckout";
import { pageAssistantProfile } from "./pages/pageAssistantProfile";
import { growtypeQuiz } from "./plugins/growtype-quiz/growtypeQuiz";
import { animateWord } from "./components/animateWord";
import { growtypePost } from "./plugins/growtype-post/growtypePost";
import { growtypeForm } from "./plugins/growtype-form/growtypeForm";
import { growtypeWc } from "./plugins/growtype-wc/growtypeWc";
import { playAudio } from "./components/playAudio";
import { storiesSlider } from './components/storiesSlider';
import { unlockedContentLoader } from "./components/unlockedContentLoader";
import { profileMenuCredits } from "./components/profileMenuCredits";
import { notificationCenter } from "./components/notificationCenter";
import { contentQualityScore } from "./components/contentQualityScore";
import { domainFunnelTracking } from "./components/domainFunnelTracking";
import { generatorAccessGate } from "./components/generatorAccessGate";
import { emailVerificationNotice } from "./components/emailVerificationNotice";
import { profileEmailCopy } from "./components/profileEmailCopy";
import { limitedUpsellPacksLink } from "./components/limitedUpsellPacksLink";
import { installTalkieMateApiV2Client } from "./services/talkiemateApiV2";

/**
 * Components
 */
animateWord();
playAudio();
unlockedContentLoader();
installTalkieMateApiV2Client();
profileMenuCredits();
notificationCenter();
contentQualityScore();
domainFunnelTracking();
generatorAccessGate();
emailVerificationNotice();
profileEmailCopy();
limitedUpsellPacksLink();

/**
 * Pages
 */
pageHome();
pageCheckout();
pageAssistantProfile();

/**
 * Plugins
 */
growtypeQuiz();
growtypePost();
growtypeForm();
growtypeWc();

storiesSlider();
